const defaultState = {
    PageInit: {/*系统初初始化*/
        current: 0,
        status: 'process',
        dwmc: '',
        dwid: '',
        yhid: '',
        yhmc: '',
        dqid: '',
        dqfhmc: '',
        zcm: '',
        description1: '',
        description2: '',
        description3: ''
    },
    homePageInit: {/*首页数据字典初始化*/
        current: 0,
        status: 'process',
        description1: '',
        description2: '',
    },
    indexPageInit: {/*主页数据字典初始化*/
        current: 0,
        status: 'process',
        description1: '',
        description2: '',
        description3: '',
        description4: '',
        description5: '',
        description6: '',
        description7: '',
        description8: '',
    },
    topContainer: {//页面信息
        pageName: 'login',
        mkid: '',
        mkmc: ''
    },
    login: {/*登录页信息*/
        userName: '',
        userNameCN: ''
    },
    objUser: {/*当前操作员信息*/
        ksdata: []//操作员所属于的科室
    },
    Dictionaries: {/*数据字典*/
        homePageSuccess: false,//首页菜单点击前识别固定字典是否初始化完成
        homePageSuccessTime: '',//首页菜单点击前识别固定字典是否初始化完成时间
        indexPageSuccess: false,//主页菜单点击判断前识别是否初始化完成
        indexPageSuccessTime: '',//主页菜单点击判断前识别是否初始化完成时间
        dm_xtgl_xzdq: { last_modified: '', list: [] },//行政区划代码（homePage初始化且首次初始化）
        dm_xtgl_xzdq_xq: { last_modified: '', list: [] },//辖区行政区划代码（homePage初始化且首次初始化）
        dm_xtgl_dwdm: { last_modified: '', list: [] },//机构代码（homePage初始化且首次初始化）
        dm_xtgl_dwdm_xq: { last_modified: '', list: [] },//辖区机构代码（homePage初始化且首次初始化）
        dm_xtgl_sjzd: { last_modified: '', list: [] },//数据字典(index初始化且当天有效)
        dm_xtgl_xtsz: { last_modified: '', list: [] },//系统配置(index初始化且当天有效)
        dm_xtgl_dw_rydm: { last_modified: '', list: [] },//人员代码(index初始化且当天有效)
        dm_xtgl_ks_rydm: { last_modified: '', list: [] },//科室人员代码(index初始化且当天有效)
        dm_xtgl_ksdm: { last_modified: '', list: [] },//科室代码(index初始化且当天有效)
        dm_xtgl_glmk: { last_modified: '', list: [] }//功能模块
    },
    homePage: {/*主页信息*/
        mkMenu: {},
        footerMenu: []
    },
    indexPage: {/*首页信息*/

    }
}

const store = (state = defaultState, action) => {
    let _combine, _state;
    switch (action.type) {
        case 'ZcmSubmit'://注册码提交
            _combine = Object.assign(state.PageInit, action.data);
            _state = Object.assign({}, state, { PageInit: _combine });
            return _state;
        case 'DataLoad'://系统初始化进度情况
            _combine = Object.assign(state.PageInit, action.data);
            _state = Object.assign({}, state, { PageInit: _combine });
            return _state;
        case 'homePageInit'://首页字典初始化对象
            _combine = Object.assign(state.homePageInit, action.data);
            _state = Object.assign({}, state, { homePageInit: _combine });
            return _state;
        case 'indexPageInit'://主页数据字典初始化对象
            _combine = Object.assign(state.indexPageInit, action.data);
            _state = Object.assign({}, state, { indexPageInit: _combine });
            return _state;
        case 'objUser'://操作员独享
            _combine = Object.assign(state.objUser, action.data);
            _state = Object.assign({}, state, { objUser: _combine });
            return _state;
        case 'topContainer'://容器对象
            _combine = Object.assign(state.topContainer, action.data);
            _state = Object.assign({}, state, { topContainer: _combine });
            return _state;
        case 'homePage'://主页对象
            _combine = Object.assign(state.homePage, action.data);
            _state = Object.assign({}, state, { homePage: _combine });
            return _state;
        case 'DictionariesXzdq'://更新行政区划代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_xzdq, action.data);
            _state = Object.assign({}, state, { dm_xtgl_xzdq: _combine });
            return _state;
        case 'DictionariesXzdqXq'://更新辖区代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_xzdq_xq, action.data);
            _state = Object.assign({}, state, { dm_xtgl_xzdq_xq: _combine });
            return _state;
        case 'DictionariesDwdm'://更新系统单位代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_dwdm, action.data);
            _state = Object.assign({}, state, { dm_xtgl_dwdm: _combine });
            return _state;
        case 'DictionariesDwdmXq'://更新辖区单位代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_dwdm_xq, action.data);
            _state = Object.assign({}, state, { dm_xtgl_dwdm_xq: _combine });
            return _state;
        case 'DictionariesRydm'://更新机构人员代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_dw_rydm, action.data);
            _state = Object.assign({}, state, { dm_xtgl_dw_rydm: _combine });
            return _state;
        case 'DictionariesKsRydm'://更新科室人员代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_ks_rydm, action.data);
            _state = Object.assign({}, state, { dm_xtgl_ks_rydm: _combine });
            return _state;
        case 'DictionariesKsdm'://更新科室人员代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_ksdm, action.data);
            _state = Object.assign({}, state, { dm_xtgl_ksdm: _combine });
            return _state;
        case 'DictionariesGlmk'://更新功能模块代码
            _combine = Object.assign(state.Dictionaries.dm_xtgl_glmk, action.data);
            _state = Object.assign({}, state, { dm_xtgl_glmk: _combine });
            return _state;
        case 'DictionariesXtsz'://更新系统配置
            _combine = Object.assign(state.Dictionaries.dm_xtgl_xtsz, action.data);
            _state = Object.assign({}, state, { dm_xtgl_xtsz: _combine });
            return _state;
        case 'DictionariesSjzd'://更新数据字典
            _combine = Object.assign(state.Dictionaries.dm_xtgl_sjzd, action.data);
            _state = Object.assign({}, state, { dm_xtgl_sjzd: _combine });
            return _state;
        case 'DictionariesState'://更新数据字典状态
            _combine = Object.assign(state.Dictionaries, action.data);
            _state = Object.assign({}, state, _combine);
            return _state;
        case 'personMsg'://更新定位的个人信息
            _combine = Object.assign(state.personMsg, action.data);
            _state = Object.assign({}, state, _combine);
            return _state;
        case 'personYcf'://孕产妇信息
            _combine = Object.assign(state.personYcf, action.data);
            _state = Object.assign({}, state, _combine);
            return _state;
        case 'patientMsg'://住院病人信息
            _combine = Object.assign(state.patientMsg, action.data);
            _state = Object.assign({}, state, _combine);
            return _state;
        case 'ObjTejh'://胎儿监护数据
            _combine = Object.assign(state.objTejh, action.data);
            _state = Object.assign({}, state, _combine);
            return _state;
        default:
            return state;
    }
}
export default store;